export default function dateTimeService() {
  return function generate(viewField, engineApi) {
    return engineApi.field
      .setCommonAttributes('ec-datetime', viewField, engineApi)
      .addAttribute('type', viewField.type)
      .addAttribute('format', viewField.metadata.format || '', true)
      .addAttribute('parse', viewField.metadata.parse || '', true);
  };
}
